var $ = require("jquery");

var selectors = {
	trigger: "#search-trigger",
	container: ".natp-search-container"
}

var triggerHtml = `
<div class='header-trigger' id='${selectors.trigger.replace("#", "")}'">
	<i class="glyphicon glyphicon-search"></i>
	<span>SEARCH</span>
</div> 
`


var create = function(containerSelector) {
	containerSelector = containerSelector || selectors.container;
	
	var actions = {
		close: () => component.$container.removeClass("open"),
		open: () => component.$container.addClass("open")
	}
    var component = { actions, $container: $(containerSelector) };

	// add the trigger
	component.$container.prepend(triggerHtml);

    $(selectors.trigger).on("click", function(e) {
        e.stopPropagation();
        $(document).trigger("header-section-toggle", component);
    });

	return component;
};

module.exports = { create: create };


// WEBPACK FOOTER //
// ./src/scripts/components/searchBox/index.js